import InputIcon from '../../../components/InputIcon';
import Form from 'react-bootstrap/Form';

function ContactSection({
  values,
  handleChange,
  handleBlur,
  errors,
  disabled,
}) {
  return (
    <div className='d-flex flex-column gap-3'>
      <h5 id='section-contact-info' className='mt-4'>
        Kontaktuppgifter
      </h5>

      <Form.Group>
        <Form.Label>Upplysningar</Form.Label>
      </Form.Group>

      <InputIcon
        type='text'
        placeholder='Ange namn'
        controlId='Contacts.Disclosures.Name'
        values={values}
        handleChange={handleChange}
        handleBlur={handleBlur}
        errors={errors}
        disabled={disabled}
      >
        <span
          className='material-symbols-outlined'
          style={{ fontSize: '20px' }}
        >
          person
        </span>
      </InputIcon>

      <InputIcon
        type='phone'
        placeholder='Ange telefonnummer'
        controlId='Contacts.Disclosures.PhoneNumber'
        values={values}
        handleChange={handleChange}
        handleBlur={handleBlur}
        errors={errors}
        disabled={disabled}
      >
        <span
          className='material-symbols-outlined material-symbols-outlined-fill'
          style={{ fontSize: '20px' }}
        >
          call
        </span>
      </InputIcon>

      <InputIcon
        type='email'
        placeholder='Ange e-post'
        controlId='Contacts.Disclosures.Email'
        values={values}
        handleChange={handleChange}
        handleBlur={handleBlur}
        errors={errors}
        disabled={disabled}
      >
        <span
          className='material-symbols-outlined'
          style={{ fontSize: '20px' }}
        >
          mail
        </span>
      </InputIcon>

      <Form.Group>
        <Form.Label>Återbud</Form.Label>
      </Form.Group>

      <InputIcon
        type='text'
        placeholder='Ange namn'
        controlId='Contacts.Cancellations.Name'
        values={values}
        handleChange={handleChange}
        handleBlur={handleBlur}
        errors={errors}
        disabled={disabled}
      >
        <span
          className='material-symbols-outlined'
          style={{ fontSize: '20px' }}
        >
          person
        </span>
      </InputIcon>

      <InputIcon
        type='phone'
        placeholder='Ange telefonnummer'
        controlId='Contacts.Cancellations.PhoneNumber'
        values={values}
        handleChange={handleChange}
        handleBlur={handleBlur}
        errors={errors}
        disabled={disabled}
      >
        <span
          className='material-symbols-outlined material-symbols-outlined-fill'
          style={{ fontSize: '20px' }}
        >
          call
        </span>
      </InputIcon>

      <InputIcon
        type='email'
        placeholder='Ange e-post'
        controlId='Contacts.Cancellations.Email'
        values={values}
        handleChange={handleChange}
        handleBlur={handleBlur}
        errors={errors}
        disabled={disabled}
      >
        <span
          className='material-symbols-outlined'
          style={{ fontSize: '20px' }}
        >
          mail
        </span>
      </InputIcon>
    </div>
  );
}

export default ContactSection;
